import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'
import { AvailableCountriesT } from 'types'

countries.registerLocale(enLocale)

export const COUNTRIES: AvailableCountriesT[] = ['DK', 'SE', 'NO', 'FI', 'FO']

export const userAllowedToAddNewSettings = [
  'tb@risika.com',
  'shk@risika.com',
  'mit@risika.com',
  'lcw@risika.com',
  'chc@risika.com',
  'asp@risika.com',
  'rpa@risika.com',
  'sud@risika.com',
]

const ZoneA_Countries = [
  { name: 'Belgium', code: 'BE' },
  { name: 'France', code: 'FR' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Italy', code: 'IT' },
  { name: 'Malta', code: 'MT' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Portugal', code: 'PT' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Spain', code: 'ES' },
  { name: 'Germany', code: 'DE' },
  { name: 'Austria', code: 'AT' },
  { name: 'United Kingdom', code: 'GB' },
]

const ZoneB_Countries = [
  { name: 'Andorra', code: 'AD' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Canada', code: 'CA' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Poland', code: 'PL' },
  { name: 'Romania', code: 'RO' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Hungary', code: 'HU' },
  { name: 'USA', code: 'US' },
]

const ZoneC_Countries = [
  { name: 'Argentina', code: 'AR' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Brazil', code: 'BR' },
  { name: 'Chile', code: 'CL' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Honduras', code: 'HN' },
  { name: 'India', code: 'IN' },
  { name: 'Iceland', code: 'IS' },
  { name: 'Israel', code: 'IL' },
  { name: 'Laos', code: 'LA' },
  { name: 'Macao', code: 'MO' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Panama', code: 'PA' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Venezuela', code: 'VE' },
]

const ZoneD_Countries = [
  { name: 'Abu Dhabi', code: 'AE' },
  { name: 'Ajman', code: 'AE' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Brunei', code: 'BN' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dubai', code: 'AE' },
  { name: 'Egypt', code: 'EG' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Philippines', code: 'PH' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'Fujairah', code: 'AE' },
  { name: 'Greece', code: 'GR' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Greenland (Danish territory)', code: 'GL' },
  { name: 'Guam (USA territory)', code: 'GU' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Dutch Atlantic territories', code: 'BQ' }, // Bonaire, Sint Eustatius and Saba
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'China', code: 'CN' },
  { name: 'Kosovo', code: 'XK' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Libya', code: 'LY' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Midway Islands (USA territory)', code: 'UM' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Macao', code: 'MO' }, // Repeated, kept for consistency with input
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Niue (New Zealand territory)', code: 'NU' },
  { name: 'North Korea', code: 'KP' },
  { name: 'North Macedonia', code: 'MK' },
  { name: 'Northern Mariana Islands (USA territory)', code: 'MP' },
  { name: 'Norfolk (Australian territory)', code: 'NF' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Panama', code: 'PA' }, // Repeated
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Pitcairn (UK territory)', code: 'PN' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Ras Al Khaimah', code: 'AE' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Samoa', code: 'WS' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Sharjah', code: 'AE' },
  { name: 'Serbia', code: 'RS' }, // Repeated
  { name: 'Last UAE emirate (Umm Al Quwain)', code: 'AE' },
  { name: 'Slovakia', code: 'SK' }, // Repeated
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'South Africa', code: 'ZA' }, // Repeated
  { name: 'South Korea', code: 'KR' },
  { name: 'Taiwan', code: 'TW' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Tokelau (New Zealand territory)', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Turkey', code: 'TR' }, // Repeated
  { name: 'UK Atlantic territories', code: 'FK' }, // Falkland Islands as example
  { name: 'Ukraine', code: 'UA' },
  { name: 'Uruguay', code: 'UY' }, // Repeated
  { name: 'USA Atlantic territories', code: 'PR' }, // Puerto Rico as example
  { name: 'USA Pacific territories', code: 'AS' }, // American Samoa as example
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' }, // Repeated
  { name: 'Yemen', code: 'YE' },
]

const ZoneE_Countries = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'Angola', code: 'AO' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Democratic Republic of the Congo', code: 'CD' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Ivory Coast', code: 'CI' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Cape Verde', code: 'CV' }, // Repeated
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Mali', code: 'ML' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Moldova', code: 'MD' }, // Repeated
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Palestine', code: 'PS' },
  { name: 'Russia', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'São Tomé and Príncipe', code: 'ST' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Somalia', code: 'SO' },
  { name: 'Sudan', code: 'SD' },
  { name: 'South Sudan', code: 'SS' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Syria', code: 'SY' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Chad', code: 'TD' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Zaire', code: 'CD' }, // Former name for Democratic Republic of the Congo
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
  { name: 'East Timor', code: 'TL' },
]

export const ZONES_AND_COUNTRIES = {
  A: ZoneA_Countries,
  B: ZoneB_Countries,
  C: ZoneC_Countries,
  D: ZoneD_Countries,
  E: ZoneE_Countries,
}

export { countries }
